/**
 * Count down to a date / time and then repeat every week
 */
function WeeklyCountdownTimer() { }

WeeklyCountdownTimer.prototype = {
    /*
     * Start with init Function
     */
    init: function () {
        // Only run code if a countdown timer element exists
        var donationCountdownTimer = document.getElementById(
            'donation-countdown-timer'
        );
        if (donationCountdownTimer === null) {
            return;
        }

        //Has a timeout seconds been set?
        var target = new Date(donationCountdownTimer.dataset.target);

        if (target > 0) {
            // convert to seconds
            this.targetTime = target / 1000;
        }
        else {
            // No timeout set, so default to next Friday at noon

            // Get target time and date (in milliseconds)
            this.targetTime = this.getNextOccurrenceOfDate(Date.now(), 5, 12, 0);

            // Divide by 1000 to get seconds
            this.targetTime = Math.floor(this.targetTime / 1000);
        }

        // Bind getTimeRemaining to use in setInterval
        var boundGetTimeRemaining = this.getTimeRemaining.bind(this);
        // Set interval
        setInterval(boundGetTimeRemaining, 1000);
    },

    getNextOccurrenceOfDate: function (
        nowTime,
        targetDay,
        targetHour,
        targetMinutes
    ) {
        // Convert back to date object
        this.targetTime = new Date(nowTime);

        // Work out how many days left until the target
        this.targetTime.setDate(
            this.targetTime.getDate() +
            ((7 + targetDay - this.targetTime.getDay()) % 7)
        );
        // Work out how many hours and minutes etc left until the target
        this.targetTime.setHours(targetHour, targetMinutes, 0, 0);
        // Add seven days if it is the target
        if (this.targetTime < new Date()) {
            this.targetTime.setDate(this.targetTime.getDate() + 7);
        }
        return this.targetTime;
    },

    getTimeRemaining: function () {
        // Get time and date now (in milliseconds)
        this.currentTime = new Date();
        // Divide by 1000 to get seconds
        this.currentTime = Math.floor(this.currentTime / 1000);

        // Minus currentTime from targetTime to get remaining time in seconds
        this.timeRemaining = this.targetTime - this.currentTime;

        // Once difference is 0, add 7 days (604,800 seconds) to new targetTime
        if (this.timeRemaining <= 0) {
            this.targetTime += 604800;
        }

        this.formatTime(this.timeRemaining);
        $('#donation-countdown-timer').css('visibility', 'visible');
    },

    formatTime: function (timeInSeconds) {
        // Format time in to human readable time
        // Work out how many days are left in the remaining time
        var days = Math.floor(timeInSeconds / 86400);
        // Remaining seconds after taking off days
        timeInSeconds %= 86400;
        // Repeat for hours, minutes, and seconds
        var hours = Math.floor(timeInSeconds / 3600);
        // Remaining seconds after taking off hours
        timeInSeconds %= 3600;
        var minutes = Math.floor(timeInSeconds / 60);
        // Remaining seconds after taking off minutes
        timeInSeconds %= 60;

        this.addTimeToHTML(days, hours, minutes, timeInSeconds);
    },

    addTimeToHTML: function (days, hours, minutes, seconds) {
        // Add days, hours, minutes, seconds to html
        document.getElementById('js-donation-countdown-days').innerHTML = days;
        document.getElementById('js-donation-countdown-hours').innerHTML = hours;
        document.getElementById(
            'js-donation-countdown-minutes'
        ).innerHTML = minutes;
        document.getElementById(
            'js-donation-countdown-seconds'
        ).innerHTML = seconds;
    }
};

this.WeeklyCountdownTimer = WeeklyCountdownTimer;

$(function () {
    window.WeeklyCountdownTimer.prototype.init();
});